import React from 'react';
import Navbar from '../components/Navbar';
import Testimonials from '../components/Testimonials';
import QuickTiles from '../components/QuickTiles';
import Footer from '../components/Footer';
import { FaBullseye, FaEye } from 'react-icons/fa';

const AboutUs = () => {
  return (
    <main className="text-gray-800 bg-gray-50">
      <Navbar />
         <section className="pt-12 pb-16 bg-gray-50">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid max-w-lg grid-cols-1 mx-auto lg:max-w-full lg:items-center lg:grid-cols-2 gap-y-12 lg:gap-x-16">
          
          {/* Text Area */}
          <div>
            <div className="text-center lg:text-left">
              <h1 className="text-4xl font-bold leading-tight text-gray-900 sm:text-5xl lg:text-6xl">
                Empowering Global Learners
              </h1>
              <p className="mt-4 text-lg text-gray-600 sm:mt-8">
                At <strong>Blessed Montessori</strong>, we believe in nurturing the whole child — intellectually, socially, emotionally, and spiritually — to shape tomorrow’s global citizens.
              </p>

              {/* Optional newsletter or contact input */}
              <form action="#" method="POST" className="mt-10">
                <div className="relative p-2 sm:border sm:border-gray-400 group sm:rounded-xl sm:focus-within:ring-1 sm:focus-within:ring-gray-900 sm:focus-within:border-gray-900">
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    className="block w-full px-4 py-4 text-gray-900 placeholder-gray-900 bg-transparent border border-gray-400 outline-none focus:border-gray-900 focus:ring-1 focus:ring-gray-900 rounded-xl sm:border-none sm:focus:ring-0 sm:focus:border-transparent"
                    required
                  />
                  <div className="mt-4 sm:mt-0 sm:absolute sm:inset-y-0 sm:right-0 sm:flex sm:items-center sm:pr-2">
                    <button
                      type="submit"
                      className="inline-flex px-6 py-3 text-lg font-bold text-white transition-all duration-200 bg-gray-900 rounded-lg hover:bg-gray-600 focus:outline-none"
                    >
                      Join Us
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* Stats */}
            <div className="flex items-center justify-center mt-10 space-x-6 lg:justify-start sm:space-x-8">
              <div className="flex items-center">
                <p className="text-3xl font-medium text-gray-900 sm:text-4xl">1,250+</p>
                <p className="ml-3 text-sm text-gray-900">Students<br />Worldwide</p>
              </div>

              <div className="hidden sm:block">
                <svg
                  className="text-gray-400"
                  width="16"
                  height="39"
                  viewBox="0 0 16 39"
                  fill="none"
                  stroke="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line x1="0.7" y1="10.5" x2="15.7" y2="0.5" />
                  <line x1="0.7" y1="17.5" x2="15.7" y2="7.5" />
                  <line x1="0.7" y1="24.5" x2="15.7" y2="14.5" />
                  <line x1="0.7" y1="31.5" x2="15.7" y2="21.5" />
                  <line x1="0.7" y1="38.5" x2="15.7" y2="28.5" />
                </svg>
              </div>

              <div className="flex items-center">
                <p className="text-3xl font-medium text-gray-900 sm:text-4xl">30+</p>
                <p className="ml-3 text-sm text-gray-900">Certified<br />Educators</p>
              </div>
            </div>
          </div>

          {/* Student Image */}
          <div>
            <img
              className="w-full rounded-lg shadow-lg"
              src="/images/school_img_1.jpg"
              alt="Blessed Montessori Students"
            />
          </div>
        </div>
      </div>
    </section>

                <section className="relative py-20 bg-gradient-to-r from-blue-50 via-white to-yellow-50 dark:from-neutral-800 dark:via-neutral-900 dark:to-neutral-800">
      <div className="px-4 mx-auto text-center max-w-7xl">
        <h2 className="mb-4 text-4xl font-bold text-blue-900 dark:text-yellow-400">Our Mission & Vision</h2>
        <p className="max-w-2xl mx-auto mb-12 text-lg text-gray-600 dark:text-gray-300">
          Guiding everything we do at Blessed Montessori — for today’s learners and tomorrow’s leaders.
        </p>
        

        <div className="grid items-start gap-10 md:grid-cols-2">
          {/* Mission Card */}
          <div className="bg-white dark:bg-neutral-800 p-8 rounded-2xl shadow-xl transform hover:scale-[1.02] transition-all duration-300">
            <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 text-3xl text-white bg-blue-700 rounded-full shadow-md">
              <FaBullseye />
            </div>
            <h3 className="mb-3 text-2xl font-semibold text-blue-800 dark:text-yellow-300">Our Mission</h3>
            <p className="text-gray-700 dark:text-gray-300">
              To nurture each child's unique potential by providing a balanced, values-centered education — fostering intellectual curiosity, creativity, and lifelong learning.
            </p>
          </div>

          {/* Vision Card */}
          <div className="bg-white dark:bg-neutral-800 p-8 rounded-2xl shadow-xl transform hover:scale-[1.02] transition-all duration-300">
            <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 text-3xl text-white bg-yellow-500 rounded-full shadow-md">
              <FaEye />
            </div>
            <h3 className="mb-3 text-2xl font-semibold text-blue-800 dark:text-yellow-300">Our Vision</h3>
            <p className="text-gray-700 dark:text-gray-300">
              To become a beacon of excellence in early education — empowering confident, compassionate, and globally minded learners who thrive in any environment.
            </p>
          </div>
        </div>

        {/* Optional CTA */}
        <div className="mt-16">
          <a
            href="/admission"
            className="inline-block px-8 py-4 text-lg font-semibold text-white transition bg-blue-700 rounded-lg shadow-md hover:bg-blue-800"
          >
            Join the Blessed Montessori Family 🎓
          </a>
        </div>
      </div>
    </section>
      {/* Real Feedback */}
      <Testimonials />

      {/* Key Links */}
      <QuickTiles />

      {/* Footer */}
      <Footer />
    </main>
  );
};

export default AboutUs;
